import { combineReducers } from 'redux'

import featured from './featured'
import copyPoll from './copyPoll'
import automated from './automated'

export default combineReducers({
  featured,
  copyPoll,
  automated,
})



// WEBPACK FOOTER //
// ./src/stores/polls/index.js